export const GAME_TYPE_ID_ROULETTE = 1;
export const GAME_TYPE_ID_00_ROULETTE = 2;
export const GAME_TYPE_ID_BACCARAT = 4;
export const GAME_TYPE_ID_2_X_WIN = 5;
export const GAME_TYPE_ID_RNG_ROULETTE = 6;
export const GAME_TYPE_ID_SI_FI_BACCARAT = 7;
export const GAME_TYPE_ID_BACCARAT_DRAGON_BONUS = 8;
export const GAME_TYPE_ID_RUSSKIY_POKER = 9;
export const GAME_TYPE_ID_BACCARAT_PUNTO_BANCO = 10;
export const GAME_TYPE_ID_7_MOJOS = 11;
export const GAME_TYPE_ID_TV_BET = 111;
export const GAME_TYPE_ID_TBS_2 = 222;
export const GAME_TYPE_ID_BET_SOLUTION = 333;
export const GAME_TYPE_ID_KAHUMA = 444;
export const GAME_TYPE_ID_ALTENTE = 777;
export const GAME_TYPE_ID_WAZDAN = 555;
export const GAME_TYPE_ID_KOLYSEO = 888;
export const GAME_TYPE_ID_TIPO_WIN = 19;
export const GAME_TYPE_ID_TIPO_WIN_EXCLUSIVE = 3;

export function isRoulette(gameType) {
    return [
        GAME_TYPE_ID_ROULETTE,
        GAME_TYPE_ID_00_ROULETTE,
        GAME_TYPE_ID_2_X_WIN,
        GAME_TYPE_ID_RNG_ROULETTE,
        GAME_TYPE_ID_TIPO_WIN,
        GAME_TYPE_ID_TIPO_WIN_EXCLUSIVE,
    ].includes(gameType);
}

export function isEuropeanRoulette(gameType) {
    return isRoulette(gameType) && !isAmericanRoulette(gameType);
}

export function isAmericanRoulette(gameType) {
    return [
        GAME_TYPE_ID_00_ROULETTE,
    ].includes(gameType);
}

export function isBaccarat(gameType) {
    return [
        GAME_TYPE_ID_BACCARAT,
        GAME_TYPE_ID_SI_FI_BACCARAT,
        GAME_TYPE_ID_BACCARAT_DRAGON_BONUS,
        GAME_TYPE_ID_BACCARAT_PUNTO_BANCO,
    ].includes(gameType);
}
